<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label && showLabel) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [formControl]="control"
    [placeholder]="placeholder"
    [required]="required"
    panelClass="filter-select-panel"
    (selectionChange)="onSelectionChange()">

    @if (noneEnabled) {
      <mat-option class="year-filter-select__none" [value]="noneValue">{{noneLabel}}</mat-option>
    }

    @for (option of options; track option) {
      <mat-option [value]="option">{{option}}</mat-option>
    }
  </mat-select>

  @if (control.hasError('required')) {
    <mat-error>{{label || 'Field'}} <strong>required</strong></mat-error>
  }
  @if (control.hasError('markedDuplicate')) {
    <mat-error>Make a different selection</mat-error>
  }
</mat-form-field>
